export default __webpack_public_path__ + "static/N0011-980450e6149e0752f75d3edd34b04ffc.png";